export default [
  {
    title: 'Management',
    komicon: 'k-cloud-connection',
    tagVariant: 'light-warning',
    children: [
      {
        title: 'Staff',
        komicon: 'k-user-octagon',
        route: 'staff',
        resource: 'Management - Staff',
        action: 'manage',
      },
      {
        title: 'Divisi',
        komicon: 'k-layer',
        route: 'division',
        resource: 'Management - Divisi',
        action: 'manage',
      },
      {
        title: 'Posisi',
        komicon: 'k-status-up',
        route: 'position',
        resource: 'Management - Posisi',
        action: 'manage',
      },
      {
        title: 'Kantor Operasional',
        komicon: 'k-buildings',
        route: 'operational-office',
        resource: 'Management - Kantor Operasional',
        action: 'manage',
      },
      {
        title: 'Working Space',
        komicon: 'k-building-4',
        route: 'work-space',
        resource: 'Management - Working Space',
        action: 'manage',
      },
      {
        title: 'Mode Kerja',
        komicon: 'k-brifecase-timer',
        route: 'work-mode',
        resource: 'Management - Mode Kerja',
        action: 'manage',
      },
    ],
  },
]
